import { Module, VuexModule, Action, Mutation } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import ZOHO from "@/libs/zoho-embedded-app/ZohoCrmHelper.js";
import { IFrameCredentials } from "@/core/services/api/interfaces/auth/Credentials";

@Module
export default class ZohoAppModule extends VuexModule {
  pageLoadInfo: { [index: string]: string | number | null | object } = {};
  /**
   * Get breadcrumb object for current page
   * @returns object
   */
  get getZohoApp() {
    return ZOHO.embeddedApp;
  }

  get getZohoCrm() {
    return ZOHO.CRM;
  }

  get getZohoIframePageLoadInfo() {
    return this.pageLoadInfo;
  }

  get getZohoIframePageLoadInfoValue() {
    return (key: string, defaultValue = null) => {
      const info = this.pageLoadInfo;
      console.log("getZohoIframePageLoadInfoValue", key, defaultValue, info);
      console.log("is key in info", key, info, key in info);

      return info[key] || defaultValue;
    };
  }

  @Action({ rawError: true })
  async [Actions.COMMON_ZOHO_APP_AUTHENTICATE]() {
    const context = this.context;
    return await new Promise((resolve, reject) => {
      const autoCredentials = new IFrameCredentials();
      try {
        this.getZohoApp.on(
          "PageLoad",
          (eventInfo: { [index: string]: object }) => {
            console.log("PageLoad event", eventInfo);
            //{Entity: 'Accounts', EntityId: '4228658000021037317', related_list: {…}}
            context.commit(
              Mutations.COMMON_IFRAME_SET_PAGE_LOAD_INFO,
              eventInfo
            );

            this.getZohoCrm.CONFIG.getOrgInfo()
              .then((data: { [index: string]: object }) => {
                console.log("Received: org", data);
                if ("org" in data && data.org && Array.isArray(data.org)) {
                  const org = data.org[0];
                  autoCredentials.domain = org.domain_name;
                  autoCredentials.organization_id = org.id;
                }
                if (autoCredentials.isFulfilled()) {
                  resolve(autoCredentials);
                }
              })
              .catch(reject);
            this.getZohoCrm.CONFIG.getCurrentUser()
              .then((data: { [index: string]: object }) => {
                console.log("Received: current user", data);
                if (
                  "users" in data &&
                  data.users &&
                  Array.isArray(data.users)
                ) {
                  const user = data.users[0];
                  autoCredentials.user_email = user.email;
                  autoCredentials.user_id = user.id;
                  autoCredentials.user_zuid = user.zuid;
                }

                if (autoCredentials.isFulfilled()) {
                  resolve(autoCredentials);
                }
              })
              .catch(reject);
          }
        );

        this.getZohoApp.init();
        console.log("Zoho SDK initialized successfully.");
      } catch (error) {
        console.error("Failed to initialize Zoho SDK:", error);
      }
    })
      .then((credentials) =>
        this.context.dispatch(Actions.COMMON_AUTH_IFRAME_LOGIN, credentials)
      )
      .catch(console.error);
  }

  @Mutation
  [Mutations.COMMON_IFRAME_SET_PAGE_LOAD_INFO](context: {
    [index: string]: string | number | null | object;
  }) {
    console.log("Setting page load info", context);
    this.pageLoadInfo = context;
  }
}
